import { IS_PRODUCTION } from '@dtx-company/true-common/src/constants/env'

export const flowpageRoot = process.env.HOST + '/'
export const flowpageWWWRoot = `${process.env.PROTOCOL}://${
  IS_PRODUCTION ? 'www.' : ''
}${flowpageRoot}`
